export var zIndexes = {
    BOTTOM: 1,
    LOW: 50,
    MID: 75,
    HIGH: 75,
    TOP: 100
};
